import { getCouponList, getLiveCourseDetails, getMarketSettingsData, getOffersCarouselData, getStudyMaterialDetails, getTestSeriesDetails, getUserMarketPlaceHomeData, getVideoResourceDetails, setActiveTermIndex, setSelectedCouponCode, setSelectedTerm, storeCartCountData, storeUserCourseDetails } from 'actions/studentMarketPlace'
import { Tag } from 'antd'
import PageDataLoader from 'components/pageDataLoader'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import CourseDetailsDescriptionSection from './courseDetailsDescriptionSection'
import CourseDetailsFeatures from './courseDetailsFeatures'
import CourseDetailsIncludes from './courseDetailsIncludes'
import CourseDetailsLearnings from './courseDetailsLearnings'
import './courseDetailsStyles.css'
import CourseContent from './coursePageCompo/courseContent'
import CourseContentPage from './coursePageCompo/courseContentPage'
import CourseRatings from './coursePageCompo/courseRatings'
import CourseTestContent from './coursePageCompo/courseTestContent'
import ExamPattern from './coursePageCompo/examPattern'
import IndividualTests from './coursePageCompo/individualTests'
import Prerequests from './coursePageCompo/prerequests'
import RelatedCourse from './coursePageCompo/relatedCourse'
import RelatedStudyMaterial from './coursePageCompo/relatedStudyMaterial'
import StudyMaterialContent from './coursePageCompo/studyMaterialContent'
import Footer from './footer'
import MobilePageHeader from './mobilePageHeader'
import TopBar from './topBar'
import NewFooter from './newFooter'
import OfferCarouselV2 from './offerCarouselV2'
import FourOFourPage from 'pages/FourOFourPage';

function UserCourseDetailsPage({ getLiveCourseDetails, setSelectedTerm, setSelectedCouponCode, setActiveTermIndex, getStudyMaterialDetails, singleCourseDetailsDataContainer, getVideoResourceDetails, 
  getTestSeriesDetails, getUserMarketPlaceHomeData, isFromAdminPreview, getOffersCarouselData, offersCarouselData, isOffersBarVisible, couponList, 
  getCouponList,storeCartCountData, getMarketSettingsData, marketSettingData, storeUserCourseDetails }) {
  const [pageLoader, togglePageLoader] = useState(false);
  const [hasFetchStarted, setHasFetchStarted] = useState(false);
  // marketSettingData in redux can still hold whatever was left over from the
  // previous page while this page's own fresh fetch is in flight. Gate the
  // "Marketplace is Offline" / "Course Type Unavailable" screens on this so
  // they never flash briefly using stale data before correcting themselves.
  const [marketSettingsReady, setMarketSettingsReady] = useState(false);
  const location = useLocation()
  const history = useHistory();
  let url = new URL(window.location.href);
  let courseId = url.searchParams.get("id");
  useEffect(() => {
    storeUserCourseDetails(null);
    setHasFetchStarted(true);
    if (courseId == 'schollIntigratedNeet') {
      togglePageLoader(true);
      getLiveCourseDetails(264, () => { togglePageLoader(false) })
    }
    else if (courseId == 'schollIntigratedJee') {
      togglePageLoader(true);
      getLiveCourseDetails(261, () => { togglePageLoader(false) })
    }

  }, [])

  const footerRef = useRef(null); // Create a ref for Footer

  const scrollToFooter = () => {
   
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(()=>{
    storeUserCourseDetails(null);
    setHasFetchStarted(true);
    if(courseId == 'schollIntigratedNeet'){
       togglePageLoader(true);
       getLiveCourseDetails(15, () => { togglePageLoader(false) })
     }
     else if(courseId == 'schollIntigratedJee'){
       togglePageLoader(true);
       getLiveCourseDetails(16, () => { togglePageLoader(false) })
     }
 
   },[])

  useEffect(() => {
    storeUserCourseDetails(null);
    setHasFetchStarted(true);
    setMarketSettingsReady(false);
    // Set unconditionally, before we've even worked out which fetch applies.
    // isResourceUnavailable below treats "fetch started but loader isn't on"
    // as "genuinely missing" — if the loader only flipped on inside whichever
    // branch matched below, there was a render in between where it was still
    // off, which briefly (and wrongly) showed the "Course Unavailable" screen
    // for a perfectly valid, still-loading resource.
    togglePageLoader(true);
    getMarketSettingsData(false, () => setMarketSettingsReady(true));
    let currentURL = window.location.href;
    let id = currentURL?.split('=')[1]?.split('&')[0];
    const parts = currentURL?.split('&');
    const typePart = parts?.find(part => part?.includes('type='));
    getUserMarketPlaceHomeData(true, () => { })
    if (typePart) {
      const typeValue = typePart?.split('=')[1];
      if ((id && (typeValue == "liveCourses" || typeValue == "course"))) {
        getLiveCourseDetails(id, () => { togglePageLoader(false) })
      } else if ((id && (typeValue == "videoResources" || typeValue == "videoResource"))) {
        getVideoResourceDetails(id, () => { togglePageLoader(false) })
      } else if ((id && (typeValue == "studyMaterials" || typeValue == "studyMaterial"))) {
        getStudyMaterialDetails(id, () => { togglePageLoader(false) });
      } else if ((id && (typeValue == "testSeries" || typeValue == "testSeries"))) {
        getTestSeriesDetails(id, () => { togglePageLoader(false) });
      } else {
        togglePageLoader(false);
      }
    } else {
      getMarketSettingsData(false, (res) => {
        if (res?.active) {
          if (location?.state?.resourceType == "course") {
            getLiveCourseDetails(location?.state?.id, () => { togglePageLoader(false) })
          } else if (location?.state?.resourceType == "videoResource") {
            getVideoResourceDetails(location?.state?.id, () => { togglePageLoader(false) })
          } else if (location?.state?.resourceType == "studyMaterials" || location?.state?.resourceType == "studyMaterial") {
            getStudyMaterialDetails(location?.state?.id, () => { togglePageLoader(false) });
          } else if (location?.state?.resourceType == "testSeries") {
            getTestSeriesDetails(location?.state?.id, () => { togglePageLoader(false) });
          } else {
            togglePageLoader(false);
          }
        } else{
          history.push("/login")
        }
      })
    }
  }, [location?.state?.id]);
  useEffect(() => { setActiveTermIndex(0); setSelectedTerm(null); getCouponList({ disablePagination: true }); getOffersCarouselData() }, [])
  const [isCategoryClicked, setIsCategoryClicked] = useState(false);
  const [isProfileClicked, setIsProfileClicked] = useState(false);

  const selectedTags = location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ? singleCourseDetailsDataContainer?.course?.tags :
    location?.state?.resourceType == "videoResource" || singleCourseDetailsDataContainer?.videoResource ? singleCourseDetailsDataContainer?.videoResource?.tags :
      location?.state?.resourceType == "studyMaterial" || singleCourseDetailsDataContainer?.studyMaterial ? singleCourseDetailsDataContainer?.studyMaterial?.tags :
        singleCourseDetailsDataContainer?.testSeriesDetails?.tags
        const [isCategories, setCategories] = useState([{
          categoriesName: null,
          subCategoriesName: null
        }])
  const [hideBanner, SetHidBanner] = useState(false)
  const [userSearchDataContainer, setUserSearchData] = useState(null);
  const [autocompleteSearchedValue, setAutocompleteSearchedValue] = useState(null)
  const [courses, setCourses] = useState(storeCartCountData.items || []);
  const [isCategoryId, setCategoryId] = useState(null)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const getTypeValue = () => {
    try {
      let urlObj = new URL(window.location.href);
      let t = urlObj.searchParams.get("type");
      if (t) return t;
    } catch (e) {}
    try {
      let currentURL = window.location.href;
      const parts = currentURL?.split('&');
      const typePart = parts?.find(part => part?.includes('type='));
      if (typePart) return typePart.split('=')[1];
    } catch (e) {}
    return null;
  };

  const getCourseTypeKey = (type) => {
    if (type === "liveCourses" || type === "course") return "liveCourseSelected";
    if (type === "videoResources" || type === "videoResource") return "videoResourceSelected";
    if (type === "studyMaterials" || type === "studyMaterial") return "studyMaterialSelected";
    if (type === "onlineTestSeries" || type === "testSeries") return "onlineTestSelected";
    return null;
  };

  const currentType = getTypeValue();
  const settingKey = getCourseTypeKey(currentType);
  const isTypeDisabled = marketSettingsReady && marketSettingData && settingKey && marketSettingData[settingKey] === false;

  if (marketSettingsReady && marketSettingData && Object.keys(marketSettingData).length > 0 && !marketSettingData.active) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FAFAFA',
        padding: '24px',
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '500px',
          width: '100%',
          padding: '40px 24px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          boxShadow: '0 8px 32px rgba(89, 64, 153, 0.05)',
          border: '1px solid #EAEAEA',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#FFEBEB',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FF414D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="m16 8-8 8" />
              <path d="m8 8 8 8" />
            </svg>
          </div>
          <h2 style={{
            fontSize: '24px',
            color: '#1F1F1F',
            fontWeight: 700,
            marginBottom: '12px'
          }}>Marketplace is Offline</h2>
          <p style={{
            fontSize: '15px',
            color: '#636363',
            lineHeight: '1.6',
            marginBottom: '32px'
          }}>
            The marketplace is currently inactive. <br />
            Please contact your administrator for more information.
          </p>
          <button 
            onClick={() => history.push('/')}
            style={{
              padding: '12px 32px',
              backgroundColor: '#594099',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(89, 64, 153, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#473180';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#594099';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  if (isTypeDisabled) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FAFAFA',
        padding: '24px',
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '500px',
          width: '100%',
          padding: '40px 24px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          boxShadow: '0 8px 32px rgba(89, 64, 153, 0.05)',
          border: '1px solid #EAEAEA',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#FFEBEB',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FF414D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <line x1="9" y1="9" x2="15" y2="15" />
              <line x1="15" y1="9" x2="9" y2="15" />
            </svg>
          </div>
          <h2 style={{
            fontSize: '24px',
            color: '#1F1F1F',
            fontWeight: 700,
            marginBottom: '12px'
          }}>Course Type Unavailable</h2>
          <p style={{
            fontSize: '15px',
            color: '#636363',
            lineHeight: '1.6',
            marginBottom: '32px'
          }}>
            This course type is not available. Please contact admin.
          </p>
          <button 
            onClick={() => history.push('/')}
            style={{
              padding: '12px 32px',
              backgroundColor: '#594099',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(89, 64, 153, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#473180';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#594099';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  const isLoaded = singleCourseDetailsDataContainer?.course || singleCourseDetailsDataContainer?.videoResource || singleCourseDetailsDataContainer?.studyMaterial || singleCourseDetailsDataContainer?.testSeriesDetails;
  const isResourceUnavailable = hasFetchStarted && !pageLoader && !isLoaded;

  if (isResourceUnavailable) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FAFAFA',
        padding: '24px',
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '500px',
          width: '100%',
          padding: '40px 24px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          boxShadow: '0 8px 32px rgba(89, 64, 153, 0.05)',
          border: '1px solid #EAEAEA',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#FFF6EA',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FFA931" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2 style={{
            fontSize: '24px',
            color: '#1F1F1F',
            fontWeight: 700,
            marginBottom: '12px'
          }}>Course Unavailable</h2>
          <p style={{
            fontSize: '15px',
            color: '#636363',
            lineHeight: '1.6',
            marginBottom: '32px'
          }}>
            This course has been deleted or unpublished by the administrator.
          </p>
          <button 
            onClick={() => history.push('/')}
            style={{
              padding: '12px 32px',
              backgroundColor: '#594099',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(89, 64, 153, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#473180';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#594099';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div onClick={(e) => { e.stopPropagation(); setIsCategoryClicked(false); setIsProfileClicked(false) }} style={{ backgroundColor: "#FAFAFA" }}>
      <div className='mobile-topbar-parent'>
        <TopBar  
        setCategories={setCategories}
        SetHidBanner={SetHidBanner} 
        setCourses={setCourses}
setPage={setPage}
setHasMore={setHasMore}
page={page}

        setCategoryId={setCategoryId} 
        userSearchData={setUserSearchData} autocompleteSearched={setAutocompleteSearchedValue} 
         couponList={couponList} isCategoryClicked={isCategoryClicked} setIsCategoryClicked={setIsCategoryClicked} isProfileClicked={isProfileClicked} setIsProfileClicked={setIsProfileClicked} />
      </div>

      <div className='mobile-header-parent'>
        <MobilePageHeader title={
          location?.state?.resourceType == "course" ? "Live Courses" :
            location?.state?.resourceType == "videoResource" ? "Video Courses" : location?.state?.resourceType == "testSeries" ? "Online Test Series" :
              "Study Material"
        }
          onBackPress={() => { history.push("/home") }} sider={true} />
      </div>
      <div style={{}}><OfferCarouselV2 offersCarouselData={offersCarouselData} onDownloadClick={scrollToFooter} fromHomePage={true} fromStudentCart={false} fromCourseDetailsPage={true}/></div>

      <div style={{ backgroundColor: "#FAFAFA" }}>
        {singleCourseDetailsDataContainer?.course || singleCourseDetailsDataContainer?.videoResource || singleCourseDetailsDataContainer?.studyMaterial || singleCourseDetailsDataContainer?.testSeriesDetails ? (<>
          <CourseDetailsDescriptionSection
            singleCourseDetailsDataContainer={
              location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ?
                singleCourseDetailsDataContainer?.course :
                location?.state?.resourceType == "videoResource" || singleCourseDetailsDataContainer?.videoResource ?
                  singleCourseDetailsDataContainer?.videoResource :
                  location?.state?.resourceType == "testSeries" || singleCourseDetailsDataContainer?.testSeriesDetails ? singleCourseDetailsDataContainer?.testSeriesDetails :
                    singleCourseDetailsDataContainer?.studyMaterial
            }
            clickFromTestCard={location?.state?.resourceType == "testSeries" ? true : false}
            testCount={singleCourseDetailsDataContainer?.testData?.length}
            isMinOfferVisible={couponList?.minOffers?.[0]}
          />
        </>) : <></>}
        {singleCourseDetailsDataContainer?.course?.learnings?.length > 0 || singleCourseDetailsDataContainer?.videoResource?.learnings?.length > 0 || singleCourseDetailsDataContainer?.studyMaterial?.learnings?.length > 0 ?
          <CourseDetailsLearnings singleCourseDetailsDataContainer={
            location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ?
              singleCourseDetailsDataContainer?.course :
              (location?.state?.resourceType == "videoResource" || singleCourseDetailsDataContainer?.videoResource ?
                singleCourseDetailsDataContainer?.videoResource :
                singleCourseDetailsDataContainer?.studyMaterial
              )
          } /> : (<></>)}
        {singleCourseDetailsDataContainer?.course?.prerequisites?.length > 0 || singleCourseDetailsDataContainer?.videoResource?.prerequisites?.length > 0 ?
          <Prerequests singleCourseDetailsDataContainer={location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ? singleCourseDetailsDataContainer?.course?.prerequisites : singleCourseDetailsDataContainer?.videoResource?.prerequisites} /> : null}
        {singleCourseDetailsDataContainer?.course?.features?.length > 0 || singleCourseDetailsDataContainer?.videoResource?.features?.length > 0 || singleCourseDetailsDataContainer?.studyMaterial?.features?.length > 0 || singleCourseDetailsDataContainer?.testSeriesDetails?.features?.length > 0 ?
          <CourseDetailsFeatures
            singleCourseDetailsDataContainer={
              location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ? singleCourseDetailsDataContainer?.course :
                location?.state?.resourceType == "videoResource" || singleCourseDetailsDataContainer?.videoResource ? singleCourseDetailsDataContainer?.videoResource :
                  location?.state?.resourceType == "studyMaterial" || singleCourseDetailsDataContainer?.studyMaterial ? singleCourseDetailsDataContainer?.studyMaterial :
                    singleCourseDetailsDataContainer?.testSeriesDetails
            } /> : (<></>)}
        {singleCourseDetailsDataContainer?.course?.details?.length > 0 || singleCourseDetailsDataContainer?.videoResource?.details?.length > 0 ?
          <CourseDetailsIncludes singleCourseDetailsDataContainer={location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ? singleCourseDetailsDataContainer?.course : singleCourseDetailsDataContainer?.videoResource} /> : null}
        {
          location?.state?.resourceType === "testSeries" || singleCourseDetailsDataContainer?.testData ?
            <IndividualTests singleCourseDetailsDataContainer={singleCourseDetailsDataContainer} />
            :
            <></>
        }
        {location?.state?.resourceType === "course" || singleCourseDetailsDataContainer?.course ? (
          singleCourseDetailsDataContainer?.course?.subjects?.length > 0 ? (
            <CourseContent singleCourseDetailsDataContainer={singleCourseDetailsDataContainer?.course} resourceType={location?.state?.resourceType} />
          ) : (
            <></>
          )
        ) : location?.state?.resourceType === "testSeries" || singleCourseDetailsDataContainer?.testSeriesDetails ? (
          singleCourseDetailsDataContainer?.testSeriesDetails?.subjectTestSeries?.length > 0 ? (
            <CourseTestContent singleCourseDetailsDataContainer={singleCourseDetailsDataContainer?.testSeriesDetails?.subjectTestSeries} resourceType={location?.state?.resourceType} />
            // <CourseContent singleCourseDetailsDataContainer={singleCourseDetailsDataContainer?.testSeriesDetails?.subjectTestSeries} resourceType={location?.state?.resourceType} />
          ) : (
            <></>
          )
        ) : location?.state?.resourceType === "videoResource" || singleCourseDetailsDataContainer?.videoResource ? (
          <CourseContentPage />
        ) : (
          singleCourseDetailsDataContainer?.studyMaterial?.topics?.length > 0 ? (
            <StudyMaterialContent singleCourseDetailsDataContainer={singleCourseDetailsDataContainer?.studyMaterial?.topics} />
          ) : (
            <></>
          )
        )}
        {
          location?.state?.resourceType === "testSeries" && singleCourseDetailsDataContainer?.testSeriesDetails?.examPattern ?
            <ExamPattern singleCourseDetailsDataContainer={singleCourseDetailsDataContainer} />
            :
            <></>
        }
        {isFromAdminPreview && (singleCourseDetailsDataContainer?.course?.tags?.length > 0 || singleCourseDetailsDataContainer?.videoResource?.tags?.length > 0 || singleCourseDetailsDataContainer?.studyMaterial?.tags?.length > 0 || singleCourseDetailsDataContainer?.testSeriesDetails?.tags?.length > 0) ?
          <div className='course-details-learnings-parent' style={{ marginTop: 30 }}>
            <div className='course-content-header'>Tags</div>
            <div className="flex-wrap m-t-10">
              {selectedTags?.map((tag, index) =>
                <Tag
                  key={index}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#191919',
                    padding: "5px 10px",
                    borderRadius: 20,
                    border: "1px solid #636363",
                    fontSize: 14,
                    marginBottom: 10,
                  }}
                >
                  {tag}
                </Tag>
              )}
            </div>
          </div> : <></>}
        {isFromAdminPreview ? <></> :
          <>
            {location?.state?.resourceType === "studyMaterial" || singleCourseDetailsDataContainer?.studyMaterial ? (
              singleCourseDetailsDataContainer?.relatedResources?.length > 0 ? (
                <RelatedStudyMaterial singleCourseDetailsDataContainer={singleCourseDetailsDataContainer?.relatedResources} />
              ) : (
                <></>
              )
            ) : (
              singleCourseDetailsDataContainer?.relatedCourses?.length > 0 ||
                singleCourseDetailsDataContainer?.relatedResources?.length > 0 ? (
                <RelatedCourse
                  singleCourseDetailsDataContainer={
                    location?.state?.resourceType === "course" || singleCourseDetailsDataContainer?.course
                      ? singleCourseDetailsDataContainer?.relatedCourses
                      : singleCourseDetailsDataContainer?.relatedResources
                  }
                  fromTestSeries={location?.state?.resourceType == "testSeries" ? true : false}
                />
              ) : (
                <></>
              )
            )}
            {singleCourseDetailsDataContainer?.course?.ratingValue > 0 || singleCourseDetailsDataContainer?.videoResource?.ratingValue > 0 || singleCourseDetailsDataContainer?.studyMaterial?.ratingValue || singleCourseDetailsDataContainer?.testSeriesDetails?.averageRating > 0 ? (<>
              <CourseRatings
                singleCourseDetailsDataContainer={location?.state?.resourceType == "course" || singleCourseDetailsDataContainer?.course ? singleCourseDetailsDataContainer?.course
                  : location?.state?.resourceType == "videoResource" || singleCourseDetailsDataContainer?.videoResource ?
                    singleCourseDetailsDataContainer?.videoResource : location?.state?.resourceType == "testSeries" || singleCourseDetailsDataContainer?.testSeriesDetails ? singleCourseDetailsDataContainer : singleCourseDetailsDataContainer?.studyMaterial}
                location={location} />
            </>) : <></>}
          </>
        }
      </div>
      <div ref={footerRef} style={{ marginTop: 100 }}>
        <NewFooter />
      </div>

      

      <PageDataLoader visible={pageLoader} />
    </div>
  )
}
const mapStateToProps = (state) => {
  const { marketSettingData, singleCourseDetailsDataContainer, couponList, offersCarouselData, isOffersBarVisible } = state.studentMarketPlace;
  const { isFromAdminPreview } = state.courseManagement;
  const { user } = state.session
  return { marketSettingData, singleCourseDetailsDataContainer, user, isFromAdminPreview, couponList, offersCarouselData, isOffersBarVisible };
};
const mapDispatchToProps = (dispatch) => ({
  getLiveCourseDetails: (id, callBack) => dispatch(getLiveCourseDetails(id, callBack)),
  getVideoResourceDetails: (id, callback) => dispatch(getVideoResourceDetails(id, callback)),
  getStudyMaterialDetails: (id, callback) => dispatch(getStudyMaterialDetails(id, callback)),
  getTestSeriesDetails: (id, callback) => dispatch(getTestSeriesDetails(id, callback)),
  getUserMarketPlaceHomeData: (noCourse, callBack) => dispatch(getUserMarketPlaceHomeData(noCourse, callBack)),
  setActiveTermIndex: (val) => dispatch(setActiveTermIndex(val)),
  setSelectedCouponCode: (val) => dispatch(setSelectedCouponCode(val)),
  setSelectedTerm: (val) => dispatch(setSelectedTerm(val)),
  getOffersCarouselData: () => dispatch(getOffersCarouselData()),
  getCouponList: (param) => dispatch(getCouponList(param)),
  storeCartCountData: (val) => dispatch(storeCartCountData(val)),
  getMarketSettingsData: (all, callBack) => dispatch(getMarketSettingsData(all, callBack)),
  storeUserCourseDetails: (val) => dispatch(storeUserCourseDetails(val)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UserCourseDetailsPage)